@if (layout.header(); as headerComponent) {
  <div class="header-container">
    @if (isBrowser && screen.isXs()) {
      <dynamic-renderer [components]="[mobileHeader()]"> </dynamic-renderer>
    } @else {
      <dynamic-renderer [components]="[headerComponent]"> </dynamic-renderer>
    }
  </div>
}

<main class="main-grid">
  <ng-content></ng-content>
</main>

@if (layout.footer(); as footerComponent) {
  <dynamic-renderer [components]="[footerComponent]"> </dynamic-renderer>
}
